import requester from '@/lib/axios';
import Activity from '@/models/Activity';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';
import { QuestionTypeEnum } from '@/models/Question';

export async function getActivity(activityId: number): Promise<Activity> {
  const { data } = await requester().get<Activity>(`activities/${activityId}/`);
  return data;
}

export interface ActivityFilter extends BaseFilters {
  lessonId?: number;
  id?: number[];
  examId?: number;
  examAreaId?: number[];
}
export async function listActivities(params: ActivityFilter = {}) {
  const { data } = await requester().get<JsonApiResponse<Activity>>(
    'activities/',
    {
      params,
    },
  );
  return data;
}

export interface UpdateActivityParams {
  activityId: number;
  lessonId: number;
}

export const deleteActivity = async ({
  activityId,
  lessonId,
}: UpdateActivityParams) => {
  const { data } = await requester().delete<Activity>(
    `lessons/${lessonId}/activities/${activityId}/`,
  );
  return data;
};

export const createActivity = async (
  lessonId: number,
  body: Partial<Activity>,
) => {
  const { data: newActivity } = await requester().post<Activity>(
    `lessons/${lessonId}/activities/`,
    body,
  );
  return newActivity;
};

export const removeActivityFromLesson = async ({
  lessonId,
  activityId,
}: UpdateActivityParams) => {
  await requester().delete(
    `lessons/${lessonId}/remove-activity/${activityId}/`,
  );
};

export const updateActivityFromLesson = async (
  { activityId, lessonId }: UpdateActivityParams,
  activity: Partial<Activity> = {},
) => {
  const { data } = await requester().patch<Activity>(
    `lessons/${lessonId}/activities/${activityId}/`,
    activity,
  );
  return data;
};

export type ActivityQuestionOrder = {
  id: number;
  questions: Array<{
    id: number;
    identifier: string;
    type: QuestionTypeEnum;
  }>;
};

export const updateOrderQuestions = async (
  lessonId: number,
  body: ActivityQuestionOrder[],
) => {
  await requester().patch<void>(
    `lessons/${lessonId}/activities/questions/order/`,
    body,
  );
};
